import { useWatch } from '@dagens/frontend-forms';
import { AddCustomerFormValues } from '../types';
import { BackButton } from '../../../../components/page/parts/back-button';

export const AddCustomerBillingBackButton = () => {
  const state = useWatch<AddCustomerFormValues>();
  return <BackButton returnTo={{ pathname: '/customers/add/start', state }} />;
};
